import cn from 'classnames';
import PropTypes from 'prop-types';
import Illustration from 'UI/components/Illustration';
import SectionTitle from 'UI/components/SectionTitle';
import { useCaseStudiesIntro } from './utils/useCaseStudiesIntro';
import styles from './styles.module.scss';

const NewPersonIntro = (props) => {
  const {
    type,
    introSection,
    title,
    description,
    formattedDescription,
    imageUrl,
    badgeData,
    logoImagesUrls,
  } = useCaseStudiesIntro(props);

  return (
    <section
      ref={introSection}
      className={cn(styles[type], styles.section)}
    >
      <div className={styles.introSection}>
        <div className={styles.contentWrapper}>
          {imageUrl && (
            <div className={styles.personImageContainer}>
              <div className={styles.personImageWrapper}>
                <Illustration
                  priority
                  transparent
                  className={styles.personImage}
                  src={imageUrl}
                  alt={imageUrl}
                />
              </div>
              {badgeData && (
                <div className={styles.badgeContainer}>
                  <p className={styles.title}>{badgeData.title}</p>
                  <p className={styles.description}>{badgeData.description}</p>
                </div>
              )}
            </div>
          )}

          <div className={styles.introText}>
            <SectionTitle
              title={title}
              titleVariant="h1"
              description={description}
              formattedDescription={formattedDescription}
              className={styles.sectionTitle}
            />
            <div className={styles.logosContainer}>
              {logoImagesUrls?.map((item) => (
                <div
                  className={styles.listItem}
                >
                  <Illustration
                    priority
                    transparent
                    className={styles.logo}
                    src={item}
                    alt={item}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

NewPersonIntro.propTypes = {
  type: PropTypes.string.isRequired,
  introSection: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
};

export default NewPersonIntro;
